var map = {
	"./1.jpeg": "./src/assets/cards/images/1.jpeg",
	"./10.jpeg": "./src/assets/cards/images/10.jpeg",
	"./11.jpeg": "./src/assets/cards/images/11.jpeg",
	"./12.jpeg": "./src/assets/cards/images/12.jpeg",
	"./13.jpeg": "./src/assets/cards/images/13.jpeg",
	"./14.jpeg": "./src/assets/cards/images/14.jpeg",
	"./15.jpeg": "./src/assets/cards/images/15.jpeg",
	"./16.jpeg": "./src/assets/cards/images/16.jpeg",
	"./17.jpeg": "./src/assets/cards/images/17.jpeg",
	"./18.jpeg": "./src/assets/cards/images/18.jpeg",
	"./19.jpeg": "./src/assets/cards/images/19.jpeg",
	"./2.jpeg": "./src/assets/cards/images/2.jpeg",
	"./20.jpeg": "./src/assets/cards/images/20.jpeg",
	"./21.jpeg": "./src/assets/cards/images/21.jpeg",
	"./22.jpeg": "./src/assets/cards/images/22.jpeg",
	"./23.jpeg": "./src/assets/cards/images/23.jpeg",
	"./24.jpeg": "./src/assets/cards/images/24.jpeg",
	"./25.jpeg": "./src/assets/cards/images/25.jpeg",
	"./3.jpeg": "./src/assets/cards/images/3.jpeg",
	"./4.jpeg": "./src/assets/cards/images/4.jpeg",
	"./5.jpeg": "./src/assets/cards/images/5.jpeg",
	"./6.jpeg": "./src/assets/cards/images/6.jpeg",
	"./7.jpeg": "./src/assets/cards/images/7.jpeg",
	"./8.jpeg": "./src/assets/cards/images/8.jpeg",
	"./9.jpeg": "./src/assets/cards/images/9.jpeg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/cards/images sync recursive ^\\.\\/.*\\.jpeg$";